import Money from '../helpers/Money'
import AjaxCart from '../helpers/AjaxCart'

class ProductForm {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.dataset.productForm)
        this._custom = this._data.template === 'personalised'
        this._variantSelector = elem.querySelector('[data-variant-selector]')
        this._currentVariant = JSON.parse(this._variantSelector.options[this._variantSelector.selectedIndex].dataset.json)
        this._engravingRules = null
        this._moneyFormat = this._data.moneyFormat

        this._currentRules = null
        this._customStep = 1
        this._customConfirmed = false
    }

    onInit () {
        const optionSelectors = this._elem.querySelectorAll('[data-variant-option]')
        if (optionSelectors.length > 0) {
            for (var l = 0; l < optionSelectors.length; l++) {
                optionSelectors[l].addEventListener('change', () => { this.onSelectChange() })
            }
        }
        const selectLinks = this._elem.querySelectorAll('[data-select-link]')
        if (selectLinks.length > 0) {
            for (let link of selectLinks) {
                link.addEventListener('change', e => { this.customSelectLinks(e) })
            }
        }
        document.addEventListener('scroll', () => { this.onScroll() })
        this.onScroll()

        if (this._custom) {
            const datasrc = this._elem.querySelector('[data-product-custom]')
            if (datasrc) {
                this._engravingRules = JSON.parse(datasrc.dataset.productCustom)
                this._currentRules = this._engravingRules['None'] || { 'name': 'None', 'fonts': [], 'character_limit': 12, 'uppercase': false, 'exclude': '', 'limited_characters': '' }
            }
            const textInput = this._elem.querySelector('[data-custom-text]')
            if (textInput) {
                textInput.addEventListener('change', () => { this.textValidate() })
                textInput.addEventListener('input', () => { this.textValidate() })
            }
            const deleteButtons = this._elem.querySelectorAll('[data-custom-delete]')
            if (deleteButtons.length > 0) {
                for (var i = 0; i < deleteButtons.length; i++) {
                    deleteButtons[i].addEventListener('click', (e) => { e.preventDefault(); this.customWarning(() => { this.clearCustomisations() }) })
                }
            }
            const customClose = this._elem.querySelectorAll('[data-custom-close]')
            if (customClose.length > 0) {
                customClose.forEach(button => {
                    button.addEventListener('click', (e) => { e.preventDefault(); this.customClose() })
                })
            }
            const customStart = this._elem.querySelector('[data-custom-start]')
            if (customStart) {
                customStart.addEventListener('click', (e) => {
                    e.preventDefault()
                    if (this._customConfirmed) {
                        this.customEdit()
                    } else {
                        this.customStart()
                    }
                })
            }
            const customConfirm = this._elem.querySelectorAll('[data-custom-confirm]')
            if (customConfirm.length > 0) {
                customConfirm.forEach(button => {
                    button.addEventListener('click', (e) => { e.preventDefault(); this.customConfirm() })
                })
            }
            const customEdit = this._elem.querySelectorAll('[data-custom-edit]')
            if (customEdit.length > 0) {
                for (var j = 0; j < customEdit.length; j++) {
                    customEdit[j].addEventListener('click', (e) => { e.preventDefault(); this.customEdit() })
                }
            }
            const form = this._elem.querySelector('[data-form]')
            if (form) {
                form.addEventListener('submit', (e) => { e.preventDefault(); this.customValidate(e) })
            }
            const swatches = this._elem.querySelectorAll('[data-color-swatch]')
            if (swatches.length > 0) {
                for (var k = 0; k < swatches.length; k++) {
                    swatches[k].addEventListener('click', (e) => { this.customSwatches(e) })
                }
            }
            // this.clearCustomisations()
        } else {
            const form = this._elem.querySelector('[data-form]')
            if (form) {
                form.addEventListener('submit', (e) => { this.submitForm() })
            }
        }
    }

    onSelectChange () {
        // let model = ''
        // let engraving = ''
        // const modelSelector = this._elem.querySelector('[data-model-selector]')
        // if (modelSelector) {
        //     model = modelSelector.value
        // }
        // const engravingSelector = this._elem.querySelector('[data-engraving-selector]')
        // if (engravingSelector) {
        //     engraving = engravingSelector.value
        // }
        // this.changeVariant(model, engraving)
        this.checkVariant()
        this.changeImage()
        this.changePrice()
        this.changeButton()
        this.changeCustomRules()
        this.updateHistoryState()
    }

    changeVariant (model, engraving) {
        // let index = this._variantSelector.selectedIndex
        // for (let i = 0; i < this._variantSelector.options.length; i++) {
        //     let option = this._variantSelector.options[i]
        //     let data = JSON.parse(option.dataset.json)
        //     if (data.model === model && data.engraving === engraving) {
        //         index = i
        //     }
        // }
        // this._variantSelector.selectedIndex = index
        // this._currentVariant = JSON.parse(this._variantSelector.options[index].dataset.json)
    }

    /**
    * Update history state for product deeplinking
    *
    * @param {object} variant - Currently selected variant
    */
    updateHistoryState () {
        if (!history.replaceState || !this._currentVariant) {
            return
        }

        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this._currentVariant.id
        window.history.replaceState({ path: newurl }, '', newurl)
    }

    checkVariant () {
        let option1 = null
        let option2 = null
        let option3 = null

        const optionSelectors = this._elem.querySelectorAll('[data-variant-option]')
        if (optionSelectors.length > 0) {
            for (var i = 0; i < optionSelectors.length; i++) {
                if (optionSelectors[i].dataset.variantOption === '1') { option1 = optionSelectors[i].value }
                if (optionSelectors[i].dataset.variantOption === '2') { option2 = optionSelectors[i].value }
                if (optionSelectors[i].dataset.variantOption === '3') { option3 = optionSelectors[i].value }
            }
        }

        let index = this._variantSelector.selectedIndex
        let variantFound = false
        for (let i = 0; i < this._variantSelector.options.length; i++) {
            let option = this._variantSelector.options[i]
            let data = JSON.parse(option.dataset.json)
            if (data.option1 === option1 && data.option2 === option2 && data.option3 === option3) {
                index = i
                variantFound = true
            }
        }
        this._variantSelector.selectedIndex = index
        this._currentVariant = JSON.parse(this._variantSelector.options[index].dataset.json)

        let engravingTypeProperty = this._elem.querySelector('[data-custom-engraving-property]')
        if (engravingTypeProperty) {
            engravingTypeProperty.value = this._currentVariant.engraving
        }
        if (!variantFound) {
            const addToCart = this._elem.querySelector('[data-add-to-cart]')
            if (addToCart) {
                let json = JSON.parse(addToCart.dataset.json)
                addToCart.disabled = 'disabled'
                addToCart.innerHTML = json.sold_out
            }
        }
    }

    changeImage () {
        let productSlider = this._theme.getComponentsById('ProductPageSlider')
        if (productSlider) {
            let elem = productSlider._elem
            let slides = elem.querySelectorAll('.tns-item')
            for (let slide of slides) {
                if (slide.dataset.variants.split(',').includes(this._currentVariant.id)) {
                    productSlider.goToSlide(parseInt(slide.dataset.index))
                    break
                }
            }
        }
    }

    changePrice () {
        const salePrice = document.querySelectorAll('[data-sale-price]')
        if (salePrice.length > 0) {
            for (var k = 0; k < salePrice.length; k++) {
                salePrice.innerHTML = Money.formatMoney(this._currentVariant.compare_at_price, this._moneyFormat)
            }
        }
        const totalPrice = document.querySelectorAll('[data-total-price]')
        if (totalPrice.length > 0) {
            for (var i = 0; i < totalPrice.length; i++) {
                totalPrice[i].innerHTML = Money.formatMoney(this._currentVariant.price, this._moneyFormat)
            }
        }
        const basePrice = this._elem.querySelector('[data-base-price]')
        if (basePrice) {
            let base = this._currentVariant.price - this._currentVariant.engraving_cost
            basePrice.innerHTML = Money.formatMoney(base, this._moneyFormat)
        }
        const servicePrice = this._elem.querySelector('[data-service-price]')
        if (servicePrice) {
            if (this._currentVariant.engraving_cost > 0) {
                servicePrice.classList.remove('hidden')
                const moneySpan = servicePrice.querySelector('span:first-child')
                if (moneySpan) {
                    moneySpan.innerHTML = Money.formatMoney(this._currentVariant.engraving_cost, this._moneyFormat)
                }
            } else {
                servicePrice.classList.add('hidden')
            }
        }
    }

    changeButton () {
        const addToCart = this._elem.querySelector('[data-add-to-cart]')
        if (addToCart) {
            let json = JSON.parse(addToCart.dataset.json)
            addToCart.disabled = this._currentVariant.available ? '' : 'disabled'
            addToCart.innerHTML = this._currentVariant.available ? json.add_to_cart : json.sold_out
        }
    }

    clearCustomisations () {
        this.customInit()
        this.changeCustomStep(1)
        this.onSelectChange()
        this.generateErrors('', '[data-custom-error]')
        this.generateErrors('', '[data-form-error]')
        const fonts = this._elem.querySelectorAll('[data-custom-font]')
        if (fonts.length > 0) {
            for (var i = 0; i < fonts.length; i++) {
                fonts[i].checked = ''
            }
        }
        this._customConfirmed = false
    }
    customWarning (callback) {
        if (window.confirm('Warning: Personalisations will be lost')) {
            if (callback) {
                callback()
            } else {
                return true
            }
        } else {
            return false
        }
    }

    changeCustomStep (n) {
        this._customStep = n
        const steps = this._elem.querySelectorAll('[data-step]')
        if (steps.length > 0) {
            for (var i = 0; i < steps.length; i++) {
                steps[i].classList.add('hidden')
                if (parseInt(steps[i].getAttribute('data-step')) === this._customStep) {
                    steps[i].classList.remove('hidden')
                }
            }
        }
        const customContainer = this._elem.querySelector('.product-page__form__inner')
        if (customContainer) {
            customContainer.style.minHeight = this._customStep === 2 ? `${steps[1].offsetHeight + 40}px` : 0
        }
    }
    customStart () {
        this.customInit()
        this.changeCustomStep(2)
        this.hideForm()
    }

    customInit () {
        const engravingSelector = this._elem.querySelector('[data-engraving-selector]')
        if (engravingSelector) {
            engravingSelector.selectedIndex = 0
        }
        const customText = this._elem.querySelector('[data-custom-text]')
        if (customText) {
            customText.value = ''
        }
        const fonts = this._elem.querySelectorAll('[data-custom-font]')
        if (fonts.length > 0) {
            for (var i = 0; i < fonts.length; i++) {
                fonts[i].checked = ''
            }
            fonts[0].checked = 'checked'
        }
        this.changeCustomRules()
    }
    customEdit () {
        this.changeCustomStep(2)
    }

    customConfirm () {
        let engraving = null
        let text = null
        let font = null
        let errors = []

        const engravingSelector = this._elem.querySelector('[data-engraving-selector]')
        if (engravingSelector) {
            engraving = engravingSelector.value
        }
        const customText = this._elem.querySelector('[data-custom-text]')
        if (customText) {
            text = customText.value
        }
        const fonts = this._elem.querySelectorAll('[data-custom-font]')
        if (fonts.length > 0) {
            for (var i = 0; i < fonts.length; i++) {
                if (fonts[i].checked) {
                    font = fonts[i].value
                }
            }
        }

        if (engraving === 'None' || engraving === 'none' || engraving === null) {
            errors.push('Please Select a Service')
        }
        if (text.length === 0 || text.trim().length === 0) {
            errors.push('Please Enter your Personalised Text')
        }
        if (fonts.length > 0 && font === null) {
            errors.push('Please Select a Font')
        }
        if (errors.length > 0) {
            this.generateErrors(errors, '[data-custom-error]')
            const steps = this._elem.querySelectorAll('[data-step]')
            const customContainer = this._elem.querySelector('.product-page__form__inner')
            if (customContainer) {
                customContainer.style.minHeight = this._customStep === 2 ? `${steps[1].offsetHeight + 40}px` : 0
            }
        } else {
            this.generateErrors('', '[data-custom-error]')
            this.generateErrors('', '[data-form-error]')
            const fontSelected = this._elem.querySelector('[data-font-selected]')
            if (fontSelected) {
                fontSelected.innerHTML = font
            }
            const processSelected = this._elem.querySelector('[data-process-selected]')
            if (processSelected) {
                processSelected.innerHTML = engraving
            }
            const textEntered = this._elem.querySelector('[data-text-entered]')
            if (textEntered) {
                textEntered.innerHTML = text
            }
            this.changeCustomStep(3)
            this._customConfirmed = true
            this.showForm()
        }
    }
    generateErrors (errors, selector) {
        const errorList = this._elem.querySelector(selector)
        if (errorList) {
            errorList.innerHTML = ''
            if (errors.length > 0) {
                let towrite = ''
                towrite = `<ul>`
                for (var i = 0; i < errors.length; i++) {
                    towrite += `<li>${errors[i]}</li>`
                }
                towrite += `</ul>`
                errorList.innerHTML = towrite
            }
        }
    }
    customValidate (e) {
        if (this._customStep !== 2) {
            if (this._customStep === 1) {
                this.clearCustomisations()
            }
            this.submitForm(e)
        } else {
            this.generateErrors(['Please Confirm your Personalisations'], '[data-form-error]')
        }
    }

    customClose () {
        if (this._customConfirmed) {
            this.customConfirm()
        } else {
            this.customWarning(() => { this.clearCustomisations() })
        }
        this.showForm()
    }

    customSwatches (e) {
        if (this._customConfirmed) {
            if (!this.customWarning()) {
                e.preventDefault()
            }
        }
    }
    customSelectLinks (e) {
        if (this._customConfirmed) {
            if (!this.customWarning()) {
                e.preventDefault()
                e.currentTarget.selectedIndex = parseInt(e.currentTarget.getAttribute('data-value'))
            } else {
                window.location.href = e.currentTarget.value
            }
        } else {
            window.location.href = e.currentTarget.value
        }
    }

    onScroll () {
        if (window.innerWidth > 768) {
            const top = this._elem.parentElement.offsetTop
            const padding = 130
            if (scrollY > top - padding) {
                let toScroll = scrollY - (top - padding)
                if (toScroll < 0) { toScroll = 0 }
                let footer = document.querySelector('[data-footer]')
                if (footer) {
                    let bottom = (scrollY + padding) + this._elem.offsetHeight
                    if (bottom > footer.offsetTop) {
                        toScroll = footer.offsetTop - (this._elem.offsetHeight) - top
                    }
                }
                this._elem.style.top = `${toScroll}px`
            }
        } else {
            this._elem.style.top = `0px`
        }
    }
    changeCustomRules () {
        if (this._engravingRules) {
            let engraving = ''
            const engravingSelector = this._elem.querySelector('[data-engraving-selector]')
            if (engravingSelector) {
                engraving = engravingSelector.value
            }
            this._currentRules = engraving !== '' ? this._engravingRules[engraving] : this._currentRules
            // Font rules
            const fonts = this._elem.querySelectorAll('[data-font]')
            if (fonts.length > 0) {
                for (let font of fonts) {
                    font.classList.add('hidden')
                    const input = font.querySelector('input')
                    for (let acceptedFont of this._currentRules.fonts) {
                        if (acceptedFont.name === font.dataset.font) {
                            font.classList.remove('hidden')
                        } else {
                            if (input) { input.checked = '' }
                        }
                    }
                }
            }
            // Text entry rules
            const textInput = this._elem.querySelector('[data-custom-text]')
            if (textInput) {
                textInput.maxLength = this._currentRules.character_limit
            }
            const textInputWarning = this._elem.querySelector('[data-custom-text-warning]')
            if (textInputWarning) {
                textInputWarning.classList.add('hidden')
                if (this._currentRules.limited_characters.length > 0) {
                    textInputWarning.classList.remove('hidden')
                }
            }
            this.textValidate()
            const textCounter = this._theme.getComponentByName('CustomTextCounter')
            if (textCounter) {
                textCounter.onChange()
            }
        }
    }

    textValidate () {
        const input = this._elem.querySelector('[data-custom-text]')
        if (input) {
            // Uppercase
            if (this._currentRules.uppercase) {
                input.value = input.value.toUpperCase()
            }
            // Exclude
            let sanitized = ''
            if (this._currentRules.exclude.length > 0) {
                for (let char of input.value) {
                    if (this._currentRules.exclude.indexOf(char) === -1) {
                        sanitized += char
                    } else if (char === '"' && this._currentRules.exclude.indexOf('♠') === -1) {
                        sanitized += char
                    } else if (char === ' ' && this._currentRules.exclude.indexOf('♣') === -1) {
                        sanitized += char
                    }
                }
                input.value = sanitized
            }

            // Limited Characters
            let restricted = ''
            let available = this._currentRules.limited_characters
            if (this._currentRules.limited_characters.length > 0) {
                for (let char of input.value) {
                    if (available.indexOf(char) > -1) {
                        restricted += char
                        available = available.replace(char, '')
                    } else if (char === '"' && available.indexOf('♠') > -1) {
                        restricted += char
                        available = available.replace('♠', '')
                    } else if (char === ' ' && available.indexOf('♣') > -1) {
                        restricted += char
                        available = available.replace('♣', '')
                    }
                }
                input.value = restricted
            }
        }
    }

    async submitForm (e) {
        let notification = window.__Theme.getComponentByName('CartNotification')
        if (notification) {
            e.preventDefault()
            let payload = {}
            if (this._custom) {
                let font = ''
                let text = ''
                let engraving = ''

                const fonts = this._elem.querySelectorAll('[data-custom-font]')
                if (fonts.length > 0) {
                    for (var i = 0; i < fonts.length; i++) {
                        if (fonts[i].checked) {
                            font = fonts[i].value
                        }
                    }
                }
                const customText = this._elem.querySelector('[data-custom-text]')
                if (customText) {
                    text = customText.value
                }
                const engravingTypeProperty = this._elem.querySelector('[data-custom-engraving-property]')
                if (engravingTypeProperty) {
                    engraving = engravingTypeProperty.value
                }
                payload = {
                    'id': parseInt(this._currentVariant.id),
                    'properties': {
                        'Font': font,
                        'Text': text,
                        'Engraving Type': engraving
                    },
                    'quantity': 1
                }
            } else {
                payload = {
                    'id': parseInt(this._currentVariant.id),
                    'quantity': 1
                }
            }
            const addToCart = this._elem.querySelector('[data-add-to-cart]')
            if (addToCart) {
                addToCart.classList.add('waiting')
            }
            let response = await AjaxCart.addItem(payload)
            if (addToCart) {
                addToCart.classList.remove('waiting')
            }
            notification.open(response.product.data.product_title)
        } else {
            e.target.submit()
        }
    }

    showForm () {
        let form = document.querySelector('[data-form-inner]')
        if (form) {
            form.classList.remove('hidden')
        }
    }
    hideForm () {
        let form = document.querySelector('[data-form-inner]')
        if (form) {
            form.classList.add('hidden')
        }
    }
}

export default ProductForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductForm.js